export class GChartInitEvent {
  nativeSeries: any[];
  mergeOptionsFn: Function;

  constructor(init?: GChartInitEvent) {
    Object.assign(this, init);
  }
}
